import React from "react";

export default function HomePage() {
    return (
        <div style={styles.page}>
            {/* Hero Section */}
            <section style={styles.hero}>
                <div style={styles.heroContent}>
                    <div style={styles.badge}>
                        Online & Offline Tuition Classes
                    </div>

                    <h1 style={styles.title}>
                        Learn With <span style={styles.accent}>Payal</span>
                    </h1>

                    <p style={styles.subjects}>
                        Mathematics • Science • Computer Science • Olympiad classes
                    </p>

                    <p style={styles.description}>
                        Personalized coaching for students who want stronger concepts,
                        better grades, and more confidence in their studies.
                    </p>

                    <p style={styles.phone}>
                        📞 Call / WhatsApp: +91 9818389088
                    </p>

                    <div style={styles.stats}>
                        <div style={styles.statCard}>
                            <h2>500+</h2>
                            <span>Students Taught</span>
                        </div>

                        <div style={styles.statCard}>
                            <h2>95%</h2>
                            <span>Success Rate</span>
                        </div>

                        <div style={styles.statCard}>
                            <h2>15+</h2>
                            <span>Years Experience</span>
                        </div>
                    </div>
                </div>

                <div style={styles.heroImageContainer}>
                    <img
                        src="/images/hero.jpg"
                        alt="Teaching"
                        style={styles.heroImage}
                    />
                </div>
            </section>

           

            {/* Gallery */}
            <section style={styles.gallerySection}>
                <h2 style={styles.sectionTitle}>Learning Environment</h2>

                <div style={styles.gallery}>
                    <img src="/images/student1.jpg" alt="" style={styles.galleryImage} />
                    <img src="/images/student2.jpg" alt="" style={styles.galleryImage} />
                    <img src="/images/student3.jpg" alt="" style={styles.galleryImage} />
                </div>
            </section>
        </div>
    );
}

const styles = {
    page: {
        background: "#0f172a",
        color: "#ffffff",
        minHeight: "100vh",
        padding: "32px",
        maxWidth: "1200px",
        margin: "0 auto",
        fontFamily: "Arial, sans-serif",
    },

    hero: {
        display: "grid",
        gridTemplateColumns: "1.1fr 1fr",
        gap: "32px",
        alignItems: "center",
        marginBottom: "50px",
    },

    badge: {
        display: "inline-block",
        background: "#1e293b",
        color: "#93c5fd",
        padding: "6px 12px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: "600",
        marginBottom: "14px",
    },

    title: {
        fontSize: "56px",
        fontWeight: "800",
        margin: "0",
        lineHeight: "1.1",
    },

    accent: {
        color: "#3b82f6",
    },

    subjects: {
        fontSize: "18px",
        color: "#cbd5e1",
        marginTop: "12px",
        fontWeight: "600",
    },

    description: {
        color: "#94a3b8",
        lineHeight: "1.7",
        fontSize: "15px",
        marginTop: "16px",
        maxWidth: "520px",
    },

    phone: {
        color: "#60a5fa",
        fontSize: "18px",
        fontWeight: "700",
        marginTop: "16px",
    },

    stats: {
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        marginTop: "22px",
    },

    statCard: {
        background: "#1e293b",
        padding: "14px 18px",
        borderRadius: "14px",
        minWidth: "120px",
        textAlign: "center",
        border: "1px solid #334155",
    },

    heroImage: {
        width: "100%",
        height: "460px",
        objectFit: "cover",
        borderRadius: "20px",
        border: "1px solid #334155",
    },

    subjectSection: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        gap: "16px",
        marginBottom: "50px",
    },

    subjectCard: {
        background: "#1e293b",
        padding: "18px",
        borderRadius: "16px",
        border: "1px solid #334155",
    },

    gallerySection: {
        marginBottom: "30px",
    },

    sectionTitle: {
        textAlign: "center",
        fontSize: "26px",
        marginBottom: "20px",
        fontWeight: "700",
    },

    gallery: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        gap: "16px",
    },

    galleryImage: {
        width: "100%",
        height: "220px",
        objectFit: "cover",
        borderRadius: "16px",
        border: "1px solid #334155",
    },
};